export default "__VITE_ASSET__BwAzTUse__"